import { Controller, useForm } from "react-hook-form";
import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog";
import {
  Box,
  CircularProgress,
  debounce,
  DialogActions,
  DialogContent,
  Divider,
  FormHelperText,
  IconButton,
  InputBase,
  InputLabel,
  Paper,
  Tooltip,
} from "@mui/material";
import {
  BodyMedium,
  H6HeadlineSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import {
  PrimaryButton,
  StyledIconButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  StyledFormControl,
  StyledOutlinedInput,
} from "../../../components/StyledComponents/Inputs/Inputs.js";
import { useAuth0 } from "@auth0/auth0-react";

import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import TagList from "../../../TagMangement/Components/TagList/TagList.js";
import { useListTagsAttachedToMiners } from "../../queries/useListTagsAttachedToMiners.ts";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

const TagFormHeader = ({ setOpen }) => {
  const {
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
    setCurrentSerial
  } = useMinerPageContext();
  const { colors } = useTheme();
  console.log(
    "TagFormHeader minerPageTagListSelectionTracker",
    minerPageTagListSelectionTracker
  );
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1.5rem 0"}
    >
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        <H6HeadlineSmall>{"Miner Tag List"}</H6HeadlineSmall>

        <BodyMedium>View the tags attached to this miner.</BodyMedium>
      </Box>

      <StyledIconButton 
        colors={colors}
        onClick={() => {
          setOpen(false);
          if (minerPageTagListSelectionTracker === "compactedtaglist") {
            // Reset the selected serials when closing the dialog
            setMinerPageTagListSelectionTracker("");
          }
          setCurrentSerial('')
        }}
      >
        <CloseIcon />
      </StyledIconButton>
    </Box>
  );
};

export const TagsListDialog = ({
  setOpen,
  refetch: minerPageRefetch,
  open,
  userRole,
}) => {
  const [authToken, setAuthToken] = useState("");
  const { colors } = useTheme();

  const { getAccessTokenSilently } = useAuth0();
  const [searchValue, setSearchValue] = useState("");
  const [dsearchValue, setDSearchValue] = useState("");
  const [tagData, setTagData] = useState([]);

  const { setToastMessage, setToastOpen } = useAppContextProvider();
  const {
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
    currentSerial,
    setCurrentSerial
  } = useMinerPageContext();

  React.useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
  }, [getAccessTokenSilently]);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch: tagsDataRefetch,
    status,
    isFetched: isTagsDataFetched,
    isLoading: isTagsDataLoading,
  } = useListTagsAttachedToMiners({
    open,
    authToken,
    serialNos: [currentSerial],
    tagName: dsearchValue,
  });

  const debouncedUpdate = React.useMemo(
    () =>
      debounce((text) => {
        setDSearchValue(text); // Update the search text state
      }, 300), // 300ms debounce delay
    []
  );

  const handleSearchChange = (event) => {
    const text = event.target.value;
    console.log("Search text:", text);
    setSearchValue(text);
    debouncedUpdate(text); // Trigger the debounced function
  };

  let limit = 25;
  console.log("tagData", data);
  useEffect(() => {
    if (data && data.pages) {
      console.log(data.pages);
      const tagData =
        isTagsDataFetched && data.pages.length > 0
          ? data.pages
              .flatMap((page, pageIndex) =>
                page.msg.map((item, index) => {
                  // Generate a unique ID by combining the page index and the item index
                  return {
                    ...item,
                    id: pageIndex * limit + index,
                    isTagSelected: false,
                  };
                })
              )
              .sort((a, b) => {
                return a.tag.localeCompare(b.tag);
              })
          : [];
      setTagData((prevData) => {
        const finalData = tagData.map((item) => {
          return {
            ...item,
            isTagSelected:
              prevData.find((prevItem) => prevItem.tag === item.tag)
                ?.isTagSelected || false,
          };
        });
        return finalData;
      });
    }
  }, [data, isTagsDataFetched, limit]);

  return (
    <StyledDialog
      colors={colors}
    //   maxWidth={"md"}
    //   fullWidth
    //   open={open}
    //   // hideBackdrop
            maxWidth={"md"}
      fullWidth
      open={open}
      // hideBackdrop
      onClose={(_, reason) => {
        if (reason === "backdropClick") {
          setOpen(false);
          if (
            minerPageTagListSelectionTracker ===
            "compactedtaglist"
          ) {
            // Reset the selected serials when closing the dialog
            setMinerPageTagListSelectionTracker("");
          }
          setCurrentSerial('')
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <TagFormHeader setOpen={setOpen} />
        <Box
          display={"flex"}
          paddingTop={"1.5rem"}
          paddingBottom={"1.5rem"}
          backgroundColor={"rgba(0,0,0,0.04)"}
          borderRadius={"1rem"}
          flexDirection={"column"}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            paddingBottom={"1rem"}
            paddingLeft={"1rem"}
            alignItems={"center"}
          >
            <Paper
              component="form"
              elevation={0}
              sx={{
                p: "0 !important",
                display: "flex",
                alignItems: "center",
                width: "25rem",
              }}
              borderRadius={"6.25rem"}
            >
              <InputBase
                sx={{ ml: 4, flex: 1, "& .MuiInputBase-input": {
                  color: colors.text.primary,             // normal text
                  "::placeholder": {
                    color: colors.text.hint,
                  },
                } }}
                placeholder="Search for tags"
                onChange={handleSearchChange}
                value={searchValue}
                inputProps={{
                  "aria-label": "search for tags",
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                  }
                }}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon />
              </IconButton>
            </Paper>
          </Box>
          <TagList
            tagList={tagData || []}
            isTagsDataLoading={isTagsDataLoading}
            isTagsDataFetched={isTagsDataFetched}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            isFetchingNextPage={isFetchingNextPage}
            setTagData={setTagData}
            viewMode={true}
            maxHeight={"20rem"}
          />
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};
